var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('head-bar'),_c('main',[_c('router-view')],1),_c('foot'),(!_vm.cookiesAccepted)?_c('cookie-bar',{on:{"cookies-accepted":_vm.setCookiesAccepted}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }